import React, {PureComponent,Component} from "react";
import {Button, Modal, Layout, Table, Icon, Row, Col} from "antd";
import _ from "i18n";
import {connect} from "react-redux";
import {getInvoiceByEventDetails, displayCsvFile, displayPdfPaidInvoicesFile} from "../../../actions/thunks.js";
import {setFilteredItems} from "../../../actions/actions.js";
import {formatAmount} from "utils";
import {debounce, map, reduce} from 'lodash';
import moment from "moment";
import {Link} from "react-router";
import { Input } from 'antd';

const { Search } = Input;

class InvoiceDetail extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      search: '',
      showSpinner : false,
    };

    this.columns = [
      {
        title: _("credit-note-number"),
        dataIndex: "officialNumber",
        align: "left",
        width:97,
        whiteSpace:"normal"
      },
      {
        title: _("Date"),
        dataIndex: "documentDate",
        align: "left",
        width:80,
        render: date => moment(date).format("DD/MM/YYYY")
      },

      {
        title: _("vcs"),
        dataIndex: "vcs",
        align: "left",
        width:107,

      },


      {
        title: _("user-email"),
        align: "left",
        dataIndex: "user.mainEmail",
        width:240,

      },

      {
        title: _("organization"),
        dataIndex: "clientOrganization",
        align: "left",
        width:206,

      },


      {
        title: _("To"),
        align: "center",
        dataIndex: "issuer.abbreviation",
        width:72,
        whiteSpace:"normal"

      },


      {
        title: _("amount"),
        dataIndex: "includingVatAmount",
        align: "center",
        width:62,

        render: amount => formatAmount(amount)
      },

      {
        title: _("manual-amount"),
        align: "center",
        dataIndex: "manual.amount",
        width:99,

        render: amount => amount ? formatAmount(amount) : formatAmount(0)

      },

      {
        title: _("manual-comment"),
        align: "left",
        dataIndex: "manual.comment",
        width:109,

      },


      {
        title: _("Status"),
        align: "center",
        dataIndex: "status",
        width:51,
        render: (text, record) => _(record.status)

      },

    ];
  }

  contains(name, text) {
    if(name === null ) return;
    return (name.trim()).search(new RegExp(text, 'gi')) !== -1 || (name.trim()).search(new RegExp(text, 'gi')) === 0;
  }

  handleSearch = (value) => {
    let {paidInvoicesDetails} = this.props;
    this.setState({search: value});
    let results=paidInvoicesDetails.items.filter((elem)=>{

      return (this.contains(elem.user.mainEmail,value.trim()) || this.contains(elem.vcs,value.trim()) || this.contains(elem.clientOrganization,value.trim()) || this.contains(elem.manual && elem.manual.comment,value.trim()))
    });
    this.props.setFilteredItems(results);

  };

  componentDidMount() {
    if(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0) {
      this.props.getInvoiceByEventDetails(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null, null, this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.statisticsFilter.year && this.props.statisticsFilter.year.length > 0 ? this.props.statisticsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }


  componentDidUpdate(prevProps, prevState)
  {

    if((prevProps.recapByDay.filterDay !== this.props.recapByDay.filterDay)) {

      this.props.getInvoiceByEventDetails(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null,this.props.recapByDay.filterDay, this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.statisticsFilter.year && this.props.statisticsFilter.year.length > 0 ? this.props.statisticsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : [])
    }
  }

  calculSum = () => {
    return (this.props.paidInvoicesDetails.filteredItems).reduce((sum, { includingVatAmount , manual }) => {
      sum += parseInt(includingVatAmount);
      if (manual && manual.amount) {
        sum -= parseInt(manual.amount);
      }
      return sum
    }, 0
    )
  }


  getCsvFile = () => {
    this.setState({showSpinner: true});
    this.props.displayCsvFile(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null,this.props.recapByDay.filterDay, this.state.search.trim() !== '' ? this.state.search.trim() : null, this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.statisticsFilter.year && this.props.statisticsFilter.year.length > 0 ? this.props.statisticsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : []).then((res) => {
      this.setState({showSpinner: false});
    });
  }

  getPdfFile = () => {
    this.setState({showSpinner: true});

    this.props.displayPdfPaidInvoicesFile(this.props.statisticsFilter.apps && this.props.statisticsFilter.apps.length > 0 ? this.props.statisticsFilter.apps : [] , this.props.statisticsFilter.appRefs && this.props.statisticsFilter.appRefs.length > 0 ? this.props.statisticsFilter.appRefs : [], this.props.operationType ? this.props.operationType : null,this.props.recapByDay.filterDay, this.state.search.trim() !== '' ? this.state.search.trim() : null, this.props.auth.currentClient ? this.props.auth.currentClient.id : null, this.props.statisticsFilter.year && this.props.statisticsFilter.year.length > 0 ? this.props.statisticsFilter.year : [], this.props.statisticsFilter.appType && this.props.statisticsFilter.appType.length > 0 ? this.props.statisticsFilter.appType : []).then((res) => {
      this.setState({showSpinner: false});
    });
  }

  render() {

    let {paidInvoicesDetails} = this.props
    return (
      <div className="stats-invoice-detail ">
        <div className="flex flex-row justify-between" >

          <div className="flex items-center justify-start">
              <div className="recap-day-title">
                {_('Invoices')}

              </div>

          <div className="ml-2" style={{cursor: 'pointer'}} onClick={this.getCsvFile}>
            <Icon type="file-excel" style={{ fontSize: '20px', color: '#2495e1' }} />
          </div>

            <div className="ml-2" style={{cursor: 'pointer'}} onClick={this.getPdfFile}>
              <Icon type="file-pdf" style={{ fontSize: '20px', color: '#2495e1' }} />
            </div>

          </div>
          <div className="w-1/3">
          <Search
                placeholder="input search text"
                onChange={({target: {value}}) => this.handleSearch(value)}
                size={"small"}
                allowClear={true}
                value={this.state.search.trim()}
              />

          </div>
        </div>

        <div className="pb-4 relative">

          <Table
            rowKey="id"
            columns={this.columns}
            dataSource={paidInvoicesDetails.filteredItems.length > 0 ? paidInvoicesDetails.filteredItems : null}
            loading={paidInvoicesDetails.fetching}
            pagination={false}
            size="middle"
            className="ttp-invoice-detail-tab"
            scroll={{ x:false, y: 450 }}
          />

          {this.state.showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

            <Icon type="sync" spin style={{ fontSize: '50px'}} />

          </div> : null
          }

        </div>

        <div className="flex flex-row justify-between  self-end mt-2">
          <div className="pr-4 border-right-line"> TOTAL</div>
          <div className="div-recap-amount-total"> { formatAmount(this.calculSum()) } </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter,
  paidInvoicesDetails: state.paidInvoicesDetails,
  recapByDay: state.recapByDay,
  auth: state.auth,
});

const mapDispatchToProps = {
  getInvoiceByEventDetails,
  setFilteredItems,
  displayCsvFile,
  displayPdfPaidInvoicesFile
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceDetail);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/InvoiceDetail.js